<script setup lang="ts">
import { computed } from 'vue';

/** A thin segmented bar drawn in SVG, so widths never need an inline style attribute. */
const props = defineProps<{
  segments: readonly { value: number; tone: 'ok' | 'soft' | 'warn' | 'danger' }[];
  total: number;
  label: string;
}>();
const rects = computed(() => {
  let x = 0;
  return props.segments.map((s) => {
    const width =
      props.total > 0 ? Math.max(0, Math.min(100 - x, (100 * s.value) / props.total)) : 0;
    const rect = { x, width, tone: s.tone };
    x += width;
    return rect;
  });
});
</script>

<template>
  <svg
    class="res-bar"
    viewBox="0 0 100 6"
    preserveAspectRatio="none"
    role="img"
    :aria-label="label"
  >
    <rect x="0" y="0" width="100" height="6" rx="3" class="res-bar-track" />
    <rect
      v-for="(r, i) in rects"
      :key="i"
      :x="r.x"
      y="0"
      :width="r.width"
      height="6"
      :data-tone="r.tone"
    />
  </svg>
</template>
